/* eslint-disable camelcase */
import Promise from 'bluebird';

// TODO: fallback to google online if offline version is not working
export class GoogleLoginRepository {
  constructor({
    clientId, scope, google, GSILocal,
  }) {
    this.initCodeClientConfig = {
      client_id: clientId,
      scope,
      ux_mode: 'popup',
    };
    // check if we want to use local sdk or not
    this.GSILocal = GSILocal;
    // Keep the existing logic but using the new Google API file
    if (this.GSILocal) {
      if (window.google.GSILocal) {
        this.googleAccounts = Promise.resolve(window.google.accounts);
      } else {
        delete window.google;

        // file google.gsi.client is download from https://accounts.google.com/gsi/client
        // Remove 'consent' when call google.accounts.oauth2.requestCode
        // Origin code: if("code"===a){var g="offline";var h=c.select_account?"select_account consent":"consent"}
        // updated logic: if("code"===a){var g="offline";var h=c.select_account?"select_account":"consent"}
        this.googleAccounts = new Promise((resolve) => {
          import(/* webpackMode: 'eager' */'./client').then(() => {
            window.google.GSILocal = true;
            resolve(window.google.accounts);
          });
        });
      }
    } else {
      this.googleAccounts = Promise.resolve(google.accounts);
    }
  }

  /**
   *
   * @param {function} onSuccess - callback to handle the error
   * @param {function} onFail - callback to handle user authorized
   * @param {bool} useConsentPrompt - use consent prompt explicity to grant offline access
   * @returns {void} void
   */
  googleSignIn({
    onSuccess,
    onFail,
    useConsentPrompt = false,
    additionalParams = {},
  }) {
    this.googleAccounts.then((googleAccounts) => {
      if (googleAccounts) {
        // https://developers.google.com/identity/oauth2/web/reference/js-reference
        this.client = googleAccounts.oauth2.initCodeClient({
          ...this.initCodeClientConfig,
          ...this.GSILocal ? { select_account: !useConsentPrompt } : {},
          ...additionalParams,
          callback: (response) => {
            if (response.error) {
              onFail({
                authErrors: response.error,
              });
            } else {
              onSuccess(response);
            }
          },
          error_callback: (response) => {
            onFail({
              authErrors: response.type,
            });
          },
        });
        this.client.requestCode();
      } else {
        onFail({
          authErrors: 'googleapi_initialization_failed',
        });
      }
    });
  }
}

